import React from "react";
import { useNavigate } from "react-router-dom";
import { ActivityEntry } from "@/model/interface/Activity";
import CallActivityItem from "./CallActivityItem";
import MessageActivityItem from "./MessageActivityItem";
import FlagActivityItem from "./FlagActivityItem";
import NoteActivityItem from "./NoteActivityItem";

const ActivityItem: React.FC<{ entry: ActivityEntry }> = ({ entry }) => {
  const navigate = useNavigate();

  if (entry.type === "CALL") {
    const callId = entry.call.id;
    return <CallActivityItem call={entry.call} onOpen={callId ? () => navigate(`/calls/${callId}`) : undefined} />;
  }
  if (entry.type === "FLAG") {
    return <FlagActivityItem preview={entry.preview} phoneNumber={entry.phoneNumber} timestamp={entry.timestamp} />;
  }
  if (entry.type === "NOTE") {
    return <NoteActivityItem note={entry.note} timestamp={entry.timestamp} />;
  }
  return <MessageActivityItem message={entry.message} conversationId={entry.conversationId} />;
};

export default ActivityItem;
